import React from "react";
import { Image } from "react-bootstrap";
import logo from "../../../assets/images/logo.svg";

function ImageSection({ resultArray, className }: any) {
  const webkitStyles = {
    animationDuration: `${
      // eslint-disable-next-line no-restricted-globals
      !isNaN(resultArray.length) && resultArray.length * 10
    }s`,
    WebkitAnimationDuration: `${
      // eslint-disable-next-line no-restricted-globals
      !isNaN(resultArray.length) && resultArray.length * 10
    }s`,
  };

  return (
    <div className={className} style={webkitStyles}>
      {resultArray?.length > 0 &&
        resultArray?.map((item) => {
          return (
            <div className="py-4" key={item?.id}>
              <div className="img p-3 overflow-hidden">
                <Image src={item?.logo_image || `${logo}`} />
              </div>
            </div>
          );
        })}
    </div>
  );
}
export default ImageSection;
